<template>
  <div>
    <div class="card-box" v-if="coupon.couponId">
      <div class="vcard-body" v-if="vcardData&&vcardData.avatar">
        <Vcard
          :posterData="vcardData" :posterImg="vcardUrl" @showMark="(e)=>callingcardShow=e"
        ></Vcard>
      </div>
      <div style="padding:20rpx 32rpx;background:#fff;" :style="{'margin-top': vcardData&&vcardData.avatar ? '64px' : 0}">
        <div  v-if="coupon.discountType==='LADDER'" >
          <div class="card-content" v-for="(item, index) in coupon.ladders"
          :key="index" style='margin-bottom:12px'  @click="getWxcode">
            <div class="content-left" style="width:35%;border-right:1px dashed #FFD095;">
              <div v-if="coupon.couponType=='CASH'&&item.couponAmount!==''">¥<span style="font-size:30px;">{{item.couponAmount}}</span></div>
              <div v-if="coupon.couponType=='DISCOUNT'&& item.couponAmount!==''"><span style="font-size:30px;">{{item.couponAmount}}</span><span>折</span></div>
              <div v-if="coupon.couponType=='GIFT'"><img :src="coupon.goodsUrl" style="width:24px;height:24px;"></div>
              <div style="font-size:11px;color:#9D7C64;">有效期至{{moment(coupon.expiredDate).format('YYYY-MM-DD')}}</div>
            </div>
            <div class="contnet-right">
              <div class="right-title">
                <div class="title01">{{coupon.onlineName}}</div>
                <div class="span01">{{coupon.onlineDescription}}</div>
              </div>
            </div>
          </div>
          <div style="display:flex;align-items: center; justify-content: center;font-size:#969799;font-size:13px;margin-top:10px;color:#969799;">
              以上优惠券顾客仅可领取 1 张 
          </div>
        </div>
         <div class="card-content" v-else  @click="getWxcode()"> 
          <div class="content-left" style="width:35%;border-right:1px dashed #FFD095;">
            <div v-if="coupon.couponType=='CASH'&&coupon.couponAmount!==''">¥<span style="font-size:30px;">{{coupon.couponAmount}}</span></div>
            <div v-if="coupon.couponType=='DISCOUNT'&& coupon.couponAmount!==''"><span style="font-size:30px;">{{coupon.couponAmount}}</span>折</div>
            <div v-if="coupon.couponType=='GIFT'"><img :src="coupon.goodsUrl" style="width:24px;height:24px;"></div>
            <div style="font-size:11px;color:#9D7C64;">有效期至{{moment(coupon.expiredDate).format('YYYY-MM-DD')}}</div>
          </div>
          <div class="contnet-right">
            <div class="right-title">
              <div class="title01">{{coupon.onlineName}}</div>
              <div class="span01">{{coupon.onlineDescription}}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="background:#fff;">
        <div class="card-box-title">
          <span class="line"></span>
          <span class="name">规则说明</span>
          <span class="line"></span>
        </div>
        <div class="rule-box" v-html="transformText(coupon.instructions)"></div>
        <div class="detail-images">
          <img
            mode="widthFix"
            :src="item"
            v-for="(item, index) in coupon.goodsDetailImages"
            :key="index"
          />
        </div>
      </div>
       <!-- 参与区域     -->
      <div style="background:#fff;" v-if="coupon.restricts&&coupon.restricts.length>0">
        <div class="card-box-title">
          <span class="line"></span>
          <span class="name">参与区域</span>
          <span class="line"></span>
        </div>
        <div class="rule-box">
        仅支持在<span v-for="(item, index) in coupon.restricts"
            :key="index">{{item.cityName}}<span v-if="index!=coupon.restricts.length-1">、</span></span>的用户参与，感谢您的理解和支持。
        </div>
      </div>
      <div class="footer flex-center" v-if="!callingcardShow">
        <LinkWeappBtn
          :url="`fissionEquitys/rollDetail.html?id=${couponId}&shareId=${shareId}&rollDetailType=${couponType}&rollType=${coupon.source}&shareType=${shareType}`"
        >
          <script type="text/wxtag-template">
              <style>
                .apply-btn {
                  width: 343px;
                  background: linear-gradient(90.12deg, #EA4638 2.31%, #DC2111 99.93%);
                  color: #fff;
                  font-size: 18px;
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50px;
                  border: none;
                }
              </style>
              <button class="apply-btn"> 去小程序领取
            </button>
          </script>
        </LinkWeappBtn>
      </div>
    </div>
    <van-popup v-model="qrModel" closeable :style="{ width: '100%' }">
      <div class="qr_code">
        <img :src="url" alt="" />
        <div>微信中长按识别小程序码</div>
        <div>领取卡券</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import LinkWeappBtn from '../../components/LinkWeappBtn'
import Vcard from '../../components/Vcard'
export default {
  data() {
    return {
      qrModel: false,
      couponId: '',
      type: '5',
      from: '',
      activityId: '',
      params: {},
      loading: false,
      shareId: '',
      disabled: false,
      showShare: false,
      couponInfo: {},
      packageId: '',
      cardBag: {},
      url: '',
      detail: {},
      coupon: {},
      posterData:{},
      couponType:"",
      shareType:'',//分享的身份
       vcardUrl: '',
      vcardData: {},
       callingcardShow:false
    }
  },
  // 局部注册的组件
  components: {
    LinkWeappBtn,
    Vcard
  },
  async mounted() {
    console.log('query', this.$route.query)
    console.log('isInitWx', this.$root.$data.store.state.isInitWx)
    if (!this.$root.$data.store.state.isInitWx) {
      this.$root.$data.store.initwx(true, this.$route.query.code)
    }
    this.couponId = this.$route.query.id||""
    this.shareId = this.$route.query.shareId||""
    this.couponType =this.$route.query.couponType||this.$route.query.rollDetailType||""
    console.log('this.couponType',this.couponType)
    this.shareType =this.$route.query.shareType? this.$route.query.shareType:""
    console.log('this.shareType',this.shareType)
    if(this.$route.query.vcardDat!='undefined'){
     this.vcardData = this.$route.query && this.$route.query.vcardData ? JSON.parse(this.$route.query.vcardData) : {}
    }
     this.vcardUrl = this.$route.query.vcardUrl
          ? this.$route.query.vcardUrl
          : ''
    this.getCouponDetails()
    this.readyShare()
  },
  methods: {

    transformText(text) {
      if(text) {
        text = text.replace(/\n/g, '<br />')
        return text
      }
    },

    // md5解密活动id
    getMd5(code) {
      return new Promise((s) => {
        this.$http
          .get('aocampaign/openapi/common/parms/restore?key=' + code)
          .then((res) => {
            console.log('%c 解密', 'color:orange', res.data)
            const ids = res.data.split('&')
            this.couponId = ids[0]
            this.shareId = ids[1]
            this.couponType=ids[2]
            this.shareType=ids[3]?ids[3]:''
            console.log('%c ids', 'color:orange', this.couponId)
            s()
          })
      })
    },
    readyShare() {
      window.wx.ready(async () => {
        const shareUrl = `${location.origin}${location.pathname}#/fissionEquitys/rollDetail?id=${this.couponId}&shareId=${this.shareId}&couponType=${this.couponType}&shareType=${this.shareType}&vcardData=${encodeURIComponent(
          JSON.stringify(this.vcardData)
        )}&vcardUrl=${
              this.vcardUrl
            }`
        //需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareAppMessage({
          title: this.coupon.onlineName, // 分享标题
          desc: this.coupon.onlineDescription, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.coupon.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        window.wx.onMenuShareTimeline({
          title: this.coupon.onlineName, // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.coupon.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
      })
    },
    // 获取卡券详情
    getCouponDetails() {
      this.$http
        .get(`aocampaign/openapi/coupon/achieve/info?couponId=${this.couponId}&shareId=${this.shareId}`)
        .then((res) => {
          if (!res.data) {
            return false
          }
          // 需要对详情图片字段进行转化成数组
          this.coupon = res.data
          this.coupon.goodsDetailImages = res.data.goodsDetailImages
            ? res.data.goodsDetailImages.split(',')
            : ''
        })
    },
    async getWxcode() {
      this.url = await this.$share.getPosterNew(
        {
          id: this.couponId,
          shareId: this.shareId,
          couponType:this.couponType,
          shareType:this.shareType
        },
        'fissionEquitys/rollDetail'
      )
      this.qrModel = true
    },
  },
}
</script>

<style lang="less" scoped>
 .apply-btn {
   width: 343px;
   background: linear-gradient(270deg, #EA4638 0%, #DC2111 100%);
    color: #fff;
    font-size: 16px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    border: none;
}
.card-box {
  position: relative;
  padding-bottom: 120px;
   .title {
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 0;
    background: #fff;
    height: 64px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
    .logo {
      width: 32px;
      height: 32px;
    }
    .p3 {
      padding-left: 12px;
      padding-right: 4px;
    }
  }
  .card-content {
    background: #fcf6ea;
    padding: 16px 8px 16px 16px;
    font-size: 13px;
    color: #fd533e;
    border-radius: 5px;
    display: flex;
    .contnet-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 14px;
      box-sizing: border-box;
      flex: 1;
      .right-title {
        box-sizing: border-box;
        width: 380rpx;
        .title01 {
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 5px;
        }
        .span01 {
          font-size: 11px;
          color: #9d7c64;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .right-but {
        color: #fd533e;
        border: 1px solid #fd533e;
        box-sizing: border-box;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 71px;
        height: 32px;
      }
    }
  }
}
.footer {
  padding: 12px 0 20px 0;
  justify-content: center;
  .btn {
    padding: 0 6px;
  }
  .active {
    justify-content: center;
  }
}
.items {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 11px;
  line-height: 20px;
}
.card-box-title {
  padding: 12px 0;
  text-align: center;
  .line {
    display: inline-block;
    width: 32px;
    height: 1px;
    background: #c8c9cc;
    vertical-align: middle;
  }
  .name {
    font-size: 13px;
    margin: 0 8px;
    font-weight: 600;
  }
}
.coupon-box {
  padding: 20px;
}
.rule-box {
  padding: 0 20px 20px;
  font-size: 14px;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 22px;
}
.detail-images img {
  width: 100%;
}
.vcard-body {
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 0;
    background: #fff;
    height: 64px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
  }
</style>
